import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'

import {getExtendedClass} from './utils.js'

const CARD_ROLE = `card-adPrice`
const MONTHLY_FEE_TEST_ID = `${CARD_ROLE}-monthlyFee`

export const CardAdPriceMonthlyFee = ({
  ad,
  vertical,
  handleScrollToContactForm,
  handleScrollToFinancingTerms,
  hasFinancingData,
  monthlyFee
}) => {
  const {i18n} = useContext(Context)
  const isDesktop = useMediaQuery(useMediaQueryBreakpoints.lg)
  const lenderHasAsterisk = hasFinancingData && ad.financingData.hasSpecificLegalConditions ? '*' : ''

  const feeExists = Boolean(ad && ad.financingData && ad.financingData.fee)

  const lenderFeeText = `${i18n.t('COMMON.MONTHLY_FEE', {
    amount: feeExists ? i18n.c(ad.financingData.fee) : '-'
  })}${lenderHasAsterisk}`

  const feeValue = hasFinancingData
    ? lenderFeeText
    : i18n.t('COMMON.MONTHLY_FEE', {
        amount: monthlyFee
      })

  const handleOnClick = () => {
    handleScrollToContactForm({
      event: 'Detail Financed More Info Clicked'
    })
  }

  return (
    <div className={getExtendedClass({vertical})}>
      <span className="mt-CardAdPrice-extendedLabel">{i18n.t('COMMON.FEE_FROM')}</span>
      <p className="mt-CardAdPrice-extendedAmount" data-testid={MONTHLY_FEE_TEST_ID}>
        {feeValue}
      </p>
      {hasFinancingData && (
        <>
          {!isDesktop ? (
            <div className="mt-CardAdPrice-extendedFooter is-link" onClick={handleOnClick}>
              {i18n.t('COMMON.KNOW_MORE')}
            </div>
          ) : (
            <span className="mt-CardAdPrice-extendedFooter">
              <div className="mt-CardAdPrice-extendedFooter is-link" onClick={handleScrollToFinancingTerms}>
                {i18n.t('COMMON.TERMS_CONDITIONS_LEGAL')}
              </div>
            </span>
          )}
        </>
      )}
    </div>
  )
}

CardAdPriceMonthlyFee.propTypes = {
  ad: PropTypes.object,
  vertical: PropTypes.bool,
  handleScrollToContactForm: PropTypes.func,
  handleScrollToFinancingTerms: PropTypes.func,
  hasFinancingData: PropTypes.bool,
  monthlyFee: PropTypes.number
}
